import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiBebanPromosiService = new CrudCustom('/transaksi-beban-promosis');
export default TransaksiBebanPromosiService;
